import { getCharacterAsset, getWorldAsset, getWorldForLocation } from '../campaign/data';
import type { LocationInfo } from '../types';

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image(); image.decoding = 'async';
    image.onload = () => resolve(image); image.onerror = reject; image.src = src;
  });
}

function cover(ctx: CanvasRenderingContext2D, image: HTMLImageElement, width: number, height: number) {
  const scale = Math.max(width / image.naturalWidth, height / image.naturalHeight);
  const w = image.naturalWidth * scale; const h = image.naturalHeight * scale;
  ctx.drawImage(image, (width - w) / 2, (height - h) / 2, w, h);
}

export async function createCharacterCard(location: LocationInfo): Promise<Blob> {
  const canvas = document.createElement('canvas'); canvas.width = 1080; canvas.height = 1920;
  const ctx = canvas.getContext('2d'); if (!ctx) throw new Error('A kép nem készíthető el.');
  const [logo, character, background] = await Promise.all([
    loadImage('/assets/brand/logo.webp'), loadImage(getCharacterAsset(location)), loadImage(getWorldAsset(getWorldForLocation(location))),
  ]);
  cover(ctx, background, 1080, 1920);
  const gradient = ctx.createLinearGradient(0, 0, 0, 1920);
  gradient.addColorStop(0, 'rgba(255,249,241,.18)'); gradient.addColorStop(.5, 'rgba(48,32,79,.08)'); gradient.addColorStop(1, 'rgba(48,32,79,.78)');
  ctx.fillStyle = gradient; ctx.fillRect(0, 0, 1080, 1920);
  ctx.fillStyle = 'rgba(255,249,241,.94)'; ctx.beginPath(); ctx.roundRect(70, 80, 940, 1760, 58); ctx.fill();
  ctx.drawImage(logo, 155, 135, 770, 265);
  ctx.fillStyle = '#efe4ff'; ctx.beginPath(); ctx.arc(540, 1000, 390, 0, Math.PI * 2); ctx.fill();
  ctx.drawImage(character, 120, 540, 840, 840);
  ctx.textAlign = 'center'; ctx.fillStyle = '#30204f'; ctx.font = '900 84px system-ui, sans-serif'; ctx.fillText(location.characterName, 540, 1455);
  ctx.font = '700 42px system-ui, sans-serif'; ctx.fillStyle = '#66537d'; ctx.fillText(location.name, 540, 1528);
  ctx.fillStyle = '#30204f'; ctx.font = '800 46px system-ui, sans-serif'; ctx.fillText('9/9 pálya teljesítve', 540, 1610);
  ctx.font = '700 38px system-ui, sans-serif'; ctx.fillText('Te melyik Shibát szerzed meg?', 540, 1720);
  ctx.fillStyle = '#7b5ea8'; ctx.font = '700 30px system-ui, sans-serif'; ctx.fillText('shibadoku.mindubi.app', 540, 1785);
  return await new Promise<Blob>((resolve, reject) => canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error('A kép nem készíthető el.')), 'image/png'));
}

export function downloadBlob(blob: Blob, filename: string) {
  const link = document.createElement('a'); link.href = URL.createObjectURL(blob); link.download = filename; link.click();
  setTimeout(() => URL.revokeObjectURL(link.href), 1000);
}
